import { sealingService } from '@paragon/data-connections';
import { getLoggedInUser } from '@paragon/login-tools';

import { loadAnnotationTemplates } from './annotationTemplates';
import { loadJob } from './job';
import { AsyncThunkActionVoid } from './thunkActions';
import { loadCurrentUser, loadUser } from './users';

export const startApp = (): AsyncThunkActionVoid => async (dispatch, getState) => {
  const user = getLoggedInUser(getState());
  if (user == null) return;

  dispatch(loadCurrentUser(user));

  // Load job from URL parameter if one specified
  const params = new URLSearchParams(window.location.search);
  const jobIdString = params.get('jobId');
  if (jobIdString === null) {
    throw new Error('Job ID not given');
  }

  const jobId = parseInt(jobIdString, 10);
  await dispatch(loadJob(jobId));

  let userLoadingPromise = Promise.resolve();

  const jobState = getState().job;
  if (jobState.stampedByEmail != null) {
    userLoadingPromise = dispatch(loadUser(jobState.stampedByEmail));
  }

  sealingService.jobs.open(jobId);

  // TODO: this should happen inside a container
  const annotationLoadingPromise = dispatch(loadAnnotationTemplates());

  await Promise.all([userLoadingPromise, annotationLoadingPromise]);
};
